import {Component, Injector, OnInit} from "@angular/core";
import {BaseComponentDirective} from "../../_shared/base/base.component";
import {FormArray, FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ParameterService} from "../../_services/parameter.service";
import {AssociationService} from "./services/association.service";
import {ConfirmationDialog} from "../../_shared/dialog/confirmation.dialog";

@Component({
    selector: 'app-association-activity-form',
    templateUrl: './association-activity-form.component.html',
    styleUrls: ['../../scss/office.scss']
})
export class AssociationActivityFormComponent extends BaseComponentDirective implements OnInit {
    public form: FormGroup;

    unitBases:any = {};
    conditionTypes:any = {};
    integerLogics:any = {};

    providerId: number = null;
    providerActivityId: number = null;

    providerActivity: any = {};
    provider: any = {};

    isEdit = false;

    constructor(
        injector: Injector,
        private formBuilder: FormBuilder,
        private parameterService: ParameterService,
        private associationService: AssociationService,
    ) {
        super(injector);
        this.form = this.formBuilder.group({
            activityType: [null, [Validators.required]],
            ceuValue: [null, [Validators.required]],
            unitBase: [null, [Validators.required]],
            note: [null, [Validators.required]],
            completionQuestion: [null, [Validators.required]],
            conditions: this.formBuilder.array([]),
        });
    }

    override async ngOnInit(): Promise<void> {
        super.ngOnInit();
        this.conditionTypes = await this.parameterService.getParameterByName("CONDITION_TYPE");
        this.integerLogics = await this.parameterService.getParameterByName("INTEGER_LOGICAL_OPERATOR");
        this.unitBases = await this.parameterService.getParameterByName("UNIT_BASE");

        this.providerId = this.activatedRoute.snapshot.params.providerId;
        this.providerActivityId = this.activatedRoute.snapshot.params?.providerActivityId;

        if(this.providerActivityId) {
            this.providerActivity = await this.associationService.getByActivityId(this.providerId, this.providerActivityId);
            this.form.patchValue(this.providerActivity);
            this.isEdit = true;

            this.providerActivity.conditions.forEach((c: any) => {
                this.addConditionWithValues(0, c);
            });
        } else {
            this.addCondition(0);
        }

        this.provider = await this.associationService.getById(this.providerId);

    }

    changeConditionType($event: any, conditionIndex: number) {
        const conditions = this.form.get('conditions').get('conditions') as FormArray;
        if($event == "INTEGER") {
            conditions.at(conditionIndex).get('integerOperator').addValidators(Validators.required);
            conditions.at(conditionIndex).updateValueAndValidity();
            conditions.at(conditionIndex).get('valueIfValid').setValue(0);
        } else {
            conditions.at(conditionIndex).get('valueIfValid').setValue(true);
            conditions.at(conditionIndex).get('integerOperator').removeValidators(Validators.required);
            conditions.at(conditionIndex).updateValueAndValidity();
        }
    }

    conditions(): FormArray {
        return this.form.get('conditions') as FormArray;
    }

    addCondition(activityIndex: number) {
        const conditionFG = this.formBuilder.group({
            conditionName: [null, [Validators.required]],
            conditionType: ['BOOLEAN', [Validators.required]],
            integerLogic: ['GT', []],
            valueIfValid: ['true', [Validators.required]],
        });

        this.conditions().push(conditionFG);
    }

    addConditionWithValues(activityIndex: number, condition: any) {
        const conditionFG = this.formBuilder.group({
            conditionName: [condition.conditionName, [Validators.required]],
            conditionType: [condition.conditionType, [Validators.required]],
            integerLogic: [condition.integerOperator, []],
            valueIfValid: [condition.valueIfValid, [Validators.required]],
        });

        this.conditions().push(conditionFG);
    }

    removeCondition(activityIndex: number, conditionIndex: number) {
        const conditions = this.form.get('conditions') as FormArray;
        if(conditions.length > 1) {
            conditions.removeAt(conditionIndex);
        } else {
            this.showAlertDark('Warning', '', 'Cannot delete last remaining condition');
            return;
        }
    }

    saveActivity() {
        const validation = this.check(this.form);
        if (validation) {
            this.showAlertDark('Warning', '', 'Please complete all required fields.');
            return;
        }

        const screenWidth = window.innerWidth;
        const dialogWidth = screenWidth < 768 ? '90vw' : '800px';
        const confirm = this.dialog.open(ConfirmationDialog, {
            width: dialogWidth,
            maxWidth: '100%',
            data: {
                message: this.providerActivityId ? "Edit Association Activity" : "Save New Association Activity",
                subMessage: this.providerActivityId ? "Are you sure want to update association activity" : "Are you sure want to save association activity?",
                buttonOkLabel: this.providerActivityId ? 'Yes, Update' : 'Yes, Save',
                buttonCancelLabel: 'Cancel',
                theme: 'dark'
            }
        });
        confirm.componentInstance.result.subscribe(r => {
            if(r) {
                if(this.providerActivityId) {
                    this.associationService.updateActivity(this.form.value, this.providerId, this.providerActivityId).then(_ => {
                        this.showSnackbarDark('Association Activity', 'Association Activity has been updated successfully', '');
                        this.router.navigate(['/office/association/detail/' + this.providerId], {queryParams: {tab: 'activities'}}).then();
                    })
                } else {
                    this.associationService.saveActivity(this.form.value, this.providerId).then(_ => {
                        this.showSnackbarDark('Association Activity', 'Association Activity has been updated successfully', '');
                        this.router.navigate(['/office/association/detail/' + this.providerId], {queryParams: {tab: 'activities'}}).then();
                    })
                }

            }
        })
    }

}
